<template>
  <ReactWrapper v-if="useReactLogin" :react-component="reactComponent" />
  <Login v-else />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapState } from "vuex";
import ReactWrapper from "../util/ReactWrapper.vue";
import { LoginRoot } from "@iloq/login/App";
import { isFeatureEnabled } from "@iloq/shared/is-feature-enabled";
import { IRootState } from "@iloq/shared/IRootState";
import Login from "./Login.vue";

export default defineComponent({
  name: "LoginConnector",
  components: {
    ReactWrapper,
    Login,
  },
  data: function () {
    return {
      reactComponent: LoginRoot,
    };
  },
  computed: {
    ...mapState({
      useReactLogin(state: unknown): boolean {
        return isFeatureEnabled({
          feature: "loginReact",
          featureFlags: (state as IRootState).features,
          defaultEnabled: false,
        });
      },
    }),
  },
});
</script>
